import React from 'react';

import { withRouter } from 'react-router';
import { connect } from "react-redux";

import colors from '../../../../config/theme/colors';

import TopPanel from '../../../layouts/TopPanel/TopPanel';
import EmptyCard from '../../../ui/empty-card/EmptyCard';
import EmptyRetailers from '../../../../assets/pictos/empty-picto/empty_retailers.png';
import { ROUTE_SALES_RETAILERS } from '../../../../js/constants/route-names';
import { withTranslation } from 'react-i18next';

class DiffusionRetailers extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            filtered: [],
            ready: true,
        };
    }

    componentDidMount() {
        this.setState({
            filtered: this.props.products
        });
    }
    

    render() {
        return (
            <div>
                <TopPanel 
                    icomoon="picto-retailer"
                    colorIcomoon={colors.blue.darker.hue300}
                    title={this.props.t("spread.campaigns.manageRetailers")} 
                    subtitle={this.props.t("spread.campaigns.managePostsOfRetailers")} 
                    // handlerAdd={() => this.goTo(ROUTE_PRODUCTS_ADD)} 
                    textAdd={this.props.t("spread.campaigns.addRetailers")} 
                    handlerImport={() => this.goTo(ROUTE_SALES_RETAILERS)} 
                    textImport={this.props.t("spread.campaigns.seeRetailers")} 
                    // searchHandler={this.handleChange} 
                    gradientColor1={colors.menu.regular} 
                    gradientColor2={colors.menu.darker}
                    windowWidth={this.props.windowWidth}
                    // openForm={this.state.openForm}
                    buttonAvailable={this.state.ready}
                    // currentLang={this.state.currentLang} 
                    // handleLang={this.handleLang} 
                    locales={this.props.locales}
                    hasBorder={true}
                />
                <EmptyCard 
                    title={this.props.t("spread.campaigns.notConfigureRetailers")} 
                    subtitle={this.props.t("spread.active_assets.clickToAdd")} 
                    textButton={this.props.t("spread.campaigns.createRetailer")} 
                    picto={EmptyRetailers} 
                    onClick={() => this.handleToggleDrawer('openForm')}
                    openForm={this.state.openForm}
                />
            </div>
        );
    }
    goTo = route => {
        this.props.history.push(route);
    };
}

const mapStateToProps = state => {
    return {
        loading: state.loading,
        products: state.products,
    };
};

export default withTranslation()(withRouter(connect(mapStateToProps, null)(DiffusionRetailers)));